module.exports = __webpack_public_path__ + "img/galery-msu3-2-zoom.497ffcdb.png";